<template>
    <aside class="col-md-4 actions">

        <!-- Login Register  -->
        <template v-if="status === 'registration_open' && ! event.register_link && ! $auth.check()">
            <div class="actions-container actions-container--login">
                  <h2>{{ 'w.event-actions.book'|t }}</h2>
                  <p>{{ 'w.event-actions.text-book-guest'|t }}</p>
    
                <div class="d-flex flex-md-row align-items-start aligne-items-md-center">
                    <router-link class='btn-link mr-2' to='/register' exact>
                        <span>{{'w.event-actions.create-account'|t}}</span>
                    </router-link>
                    <router-link class='btn-link' to='/login' exact>
                        <span>{{'w.event-actions.login'|t}}</span>
                    </router-link>
                </div>
            </div>
        </template>

        <!-- External link registration -->
        <template v-if="status === 'registration_open' && event.register_link">
            <div class="actions-container actions-container--register">
                <h2>{{ 'w.event-actions.book'|t }}</h2>
    
                <a :href="event.register_link" class="btn">
                    <span>{{ 'w.event-actions.book'|t }}</span>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6">
                        <path id="Tracé_31" data-name="Tracé 31" d="M10.985,7.7,6.689,12l-.706-.706,4.3-4.3H6.492V6h5.49v5.49h-1Z" transform="translate(-5.983 -6)" fill="#acd3ae"/>
                        </svg>
                    </span>
                </a>
            </div>
        </template>

        <!-- Get ticket -->
        <template v-if="status === 'registration_open' && event.show_register_btn && ! event.register_link && $auth.check()">
            <div class="actions-container actions-container--register">
                <h2>{{ 'w.event-actions.book'|t }}</h2>
    
                <div class="register-box">
    
                    <div class="register-box--label">
                        <p>{{'w.event-actions.tickets-label'|t}}</p>
                        <p v-if="event.max_tickets_per_user">{{ availableTickets}} {{'w.event-actions.max'|t}}</p>
                    </div>
    
                    <div class="register-box--tickets">
                        <button class="button-minus" @click="removeTicket">-</button>
                        <span>{{ tickets }}</span>
                        <button class="button-plus" @click="addTicket">+</button>
                    </div>
                </div>
    
                <button class="btn" :disabled="tickets < 1" @click="addToCart">
                    <span>{{ 'w.event-actions.add-cart'|t }}</span>
                </button>
    
                <p class="conditions first">{{ 'w.event-actions.tickets-rule'|t }} <a href="/terms-of-use">{{ 'w.event-actions.cgu'|t }}</a></p>
                <p class="conditions">{{ 'w.event-actions.tickets-rule-2'|t }}</p>
            </div>
        </template>

        <!-- Login notification  -->
        <template v-if="status === 'notifications_open' && ! event.register_link && ! $auth.check()">
            <div class="actions-container actions-container--login-notifications">
                <h2>{{ 'w.event-actions.register'|t }}</h2>
    
                <p class="date">{{ 'w.event-actions.booking-start'|t }} {{ event.registration_open_date | formatDateEvent }}</p>
    
                <p>{{ 'w.event-actions.text-notify-guest'|t }}</p>
    
                <div class="d-flex flex-md-row align-items-start aligne-items-md-center">
                    <router-link class='btn-link btn-link--small mr-2' to='/register' exact>
                        <span>{{'w.event-actions.create-account'|t}}</span>
                    </router-link>
                    <router-link class='btn-link btn-link--small' to='/login' exact>
                        <span>{{'w.event-actions.login'|t}}</span>
                    </router-link>
                </div>
            </div>
        </template>

        <!-- Get notification  -->
        <template v-if="status === 'notifications_open' && ! event.register_link && $auth.check() && ! userStatus">
            <div class="actions-container actions-container--notifications">
                <div class="text">
                    <h2>{{ 'w.event-actions.register'|t }}</h2>
        
                    <p class="date">{{ 'w.event-actions.booking-start'|t }} {{ event.registration_open_date | formatDateEvent }}</p>
        
                    <p>{{ 'w.event-actions.text-notify-auth'|t }}</p>
                </div>
    
                <button class="btn" @click="toggleNotify">
                    <span>{{ 'w.event-actions.notify-me'|t }}</span>
                </button>
            </div>
        </template>

        <!-- Notification asked  -->
        <template v-if="status === 'notifications_open' && ! event.register_link && $auth.check() && userStatus === 'notification_requested'">
            <div class="actions-container actions-container--notifications-asked">

                <div class="text">
                    <h2>{{ 'w.event-actions.register'|t }}</h2>
        
                    <p class="date">{{ 'w.event-actions.booking-start'|t }} {{ event.registration_open_date | formatDateEvent }}</p>
        
                    <p>
                        <span>{{ 'w.event-actions.reminder-sub'|t }}</span>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="11.982" height="8.488" viewBox="0 0 11.982 8.488">
                            <path id="Tracé_26" data-name="Tracé 26" d="M8.129,12.469,14.62,5.979l1,1L8.129,14.466,3.636,9.973l1-1Z" transform="translate(-3.636 -5.979)" fill="#acd3ae"/>
                            </svg>
                        </span>
                    </p>
                </div>
    
                <a href="#" class="btn-link btn-link--small" @click.prevent="toggleNotify">
                    <span>{{ 'w.event-actions.unsub'|t }}</span>
                </a>
            </div>
        </template>

        <!-- Login event full  -->
        <template v-if="status === 'event_full' && ! event.register_link && ! $auth.check()">
            <div class="actions-container actions-container--login-full">
                <h2>{{ 'w.event-actions.sold-out'|t }}</h2>
    
                <p>{{ 'w.event-actions.sold-out-text-guest'|t }}</p>
    
                <div class="d-flex flex-md-row align-items-start aligne-items-md-center">
                    <router-link class='btn-link btn-link--small mr-2' to='/register' exact>
                        <span>{{'w.event-actions.create-account'|t}}</span>
                    </router-link>
                    <router-link class='btn-link btn-link--small' to='/login' exact>
                        <span>{{'w.event-actions.login'|t}}</span>
                    </router-link>
                </div>
            </div>
        </template>

        <!-- Get on waiting list -->
        <template v-if="status === 'event_full' && ! event.register_link && $auth.check() && userStatus != 'on_waiting_list' && userStatus != 'registered_and_waiting'">
            <div class="actions-container actions-container--waiting-list">

                <div class="text">
                    <h2>{{ 'w.event-actions.sold-out'|t }}</h2>
        
                    <p>{{ 'w.event-actions.sold-out-text'|t }}</p>
                </div>

                <button class="btn" @click="toggleWaitingList">
                    <span>{{ 'w.event-actions.notify-me'|t }}</span>
                </button>
            </div>
        </template>

        <!-- Is on waiting list  -->
        <template v-if="status === 'event_full' && ! event.register_link && $auth.check() && (userStatus === 'on_waiting_list' || userStatus === 'registered_and_waiting')">
            <div class="actions-container actions-container--waiting-list-asked">

                <div class="text">

                    <h2>{{ 'w.event-actions.sold-out'|t }}</h2>
        
                    <p>
                        <span>{{ 'w.event-actions.asked-for-place-text'|t }}</span>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="11.982" height="8.488" viewBox="0 0 11.982 8.488">
                            <path id="Tracé_26" data-name="Tracé 26" d="M8.129,12.469,14.62,5.979l1,1L8.129,14.466,3.636,9.973l1-1Z" transform="translate(-3.636 -5.979)" fill="#acd3ae"/>
                            </svg>
                        </span>
                    </p>
                </div>
    
                <a href="#" class="btn-link btn-link--small" @click.prevent="toggleWaitingList">
                    <span>{{ 'w.event-actions.unsub'|t }}</span>
                </a>
            </div>
        </template>

        <!-- Event over  -->
        <template v-if="status === 'event_over'">
            <div class="actions-container actions-container--event-over">
                <h2>{{ 'w.event-actions.booking-close'|t }}</h2>

                <p>{{ 'w.event-actions.booking-close-text'|t }}</p>
            </div>
        </template>

        <!-- Modal notification ok  -->
        <b-modal id="notify" ref="notifyok" size="sm" centered hide-footer hide-header>
            <div class="modal-user-notifyed">
                <h3 class="left-bullet">{{ 'w.event-actions.notify-confirmed'|t }}</h3>
                <p>{{ 'w.event-actions.stay-tuned'|t }}</p>
                <a href="#" class="btn-link btn-link--small" @click.prevent="closeModal('notifyok')">
                    {{ 'w.event-actions.close'|t }}
                </a>
            </div>
        </b-modal>

        <!-- Modal waiting list ok  -->
        <b-modal id="waitinglist" ref="waitinglistok" size="sm" centered hide-footer hide-header>
            <div class="modal-user-notifyed">
                <h3 class="left-bullet">{{ 'w.event-actions.asked-for-place-text'|t }}</h3>
                <p>{{ 'w.event-actions.asked-place-modal-text'|t }}</p>
                <a href="#" class="btn-link btn-link--small" @click.prevent="closeModal('waitinglistok')">{{ 'w.event-actions.close'|t }}</a>
            </div>
        </b-modal>
    </aside>

</template>

<script>
export default {
    props: {
        event: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            tickets: 0,
            status: null,
            userStatus: null
        }
    },
    methods: {
        addTicket() {
            if(this.tickets < this.availableTickets) {
                this.tickets++
            }
        },
        removeTicket() {
            if (this.tickets > 0) {
                this.tickets--
            }
        },
        addToCart() {
            // If user is log in
            if(! this.$auth.check()) {
                this.$router.push('login');
                return;
            }

            // field not empty
            if(! this.tickets) {
                return;
            }

            // Register participation
            Vue.axios.post('/cart', {
                event_id: this.event.id,
                nb_tickets: this.tickets,
            }).then(({data}) => {
                this.$store.setCart(data)
                this.$store.cartDropdown.show()
            }).catch(function (error) {
            })
        },
        toggleNotify() {
            if(! this.$auth.check()) {
                this.$router.push('login');
                return;
            }

            Vue.axios.post(`/events/${this.event.slug}/notify`, {
                event: this.event,
            }).then(({data}) => {

                if(data.status === 'attached') {
                    this.userStatus = 'notification_requested';
                    this.$refs.notifyok.show();
                }

                if(data.status === 'detached') {
                    this.userStatus = null;
                }
            }).catch(function (error) {
            })
        },
        closeModal(modal) {
            this.$refs[modal].hide();
        },
        toggleWaitingList() {
            if(! this.$auth.check()) {
                this.$router.push('login');
                return;
            }

            Vue.axios.post(`/events/${this.event.slug}/waiting-list`, {
                event: this.event,
            }).then(({data}) => {
                if(data.status === 'attached') {
                    if(this.userStatus === 'registered') {
                        this.userStatus = 'registered_and_waiting';
                    } else {
                        this.userStatus = 'on_waiting_list';
                    }
                    this.$refs.waitinglistok.show();
                }

                if(data.status === 'detached') {
                    if(this.userStatus === 'registered_and_waiting') {
                        this.userStatus = 'registered';
                    } else {
                        this.userStatus = null;
                    }
                }
            }).catch(function (error) {
            })
        }
    },
    computed: {
        availableTickets() {
            // 0 = no limit (capacity = global, max_tickets_per_user = per user)
            const available = this.event.capacity ? this.event.ticketsAvailable : Infinity;
            const perUser = this.event.max_tickets_per_user || Infinity;

            return Math.min(available, perUser);
        }
    },
    mounted() {
        this.status = this.event.status;
        this.userStatus = this.event.userStatus;
    }
}
</script>
